/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Snackbar, SnackbarCloseReason } from '@mui/material';
import {  IVFormErrors, VForm,  VTextFieldData, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { RomaneioService } from '../../../shared/services/api/faturamento/romaneios/RomaneioService';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { useNavigate } from 'react-router-dom';


export interface ConfirmationDialogRawProps {
    id: string;
    open: boolean;
    onClose: (value?: string) => void;
}

export const DialoFecharRomaneio: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {

  const {formRef, save, } = useVForm();
  const { onClose,  open, ...other } = props;
  const [datafechamento, setDatafechamento] = useState<Dayjs | null>(dayjs());
  const [isLoading, setIsLoading] = useState(false); 
  const navigate = useNavigate(); 
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
          
          
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if(tms === 'success'){ 
      onClose();
      navigate('/romaneios'); 
    }
  };

  const handleSave = () => {
    setIsLoading(true);
    RomaneioService.FecharRomaneio(props.id, dayjs(datafechamento).format('DD/MM/YYYY'))
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setTms('success');
          setMsg('Romaneio Fechado com sucesso!');
          setOpenmsg(true);
        }
      });
  };

  const handleCancel = () => {
    onClose();
  };
   
  return (
    <Dialog 
      open={open}
      {...other}
      maxWidth='sm'
    >
      <DialogTitle>Fechar Romaneio</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef}  onSubmit={handleSave}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Grid container direction="column" padding={1} >
            <Grid container item direction="row" padding={1} spacing={1}>
              <Grid item xs={10} sm={10} md={10} lg={10} xl={12}> 
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'
                    value={datafechamento}
                    onChange={(newValue) => setDatafechamento(newValue)}
                  />
                </LocalizationProvider>
              </Grid>  
            </Grid>  
          </Grid>  
        </VForm>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color='error' onClick={handleCancel}>Cancelar</Button>
        <Button variant='outlined' autoFocus onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog>
    
  );
};